import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
    fill?: string;
};

export const ChevronsRightIcon = (props: Props) => {
    const { width = 16, height = 14, fill = 'currentColor', ...rest } = props;
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path d="M9 7L3.15332 13.5H0L5.88867 7.00879L0 0.5H3.15332L9 7ZM16 7L10.1533 13.5H7L12.8887 7.00879L7 0.5H10.1533L16 7Z" fill={fill} />
        </svg>
    );
};
